module.exports = __webpack_public_path__ + "static/media/20000524_3.48b41531.jpg";